import { render, staticRenderFns } from "./_base-icon.vue?vue&type=template&id=74eb654c"
import script from "./_base-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-icon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports